var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var validate = ref.validate;
return [_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.update(validate)}}},[_c('client-form',{attrs:{"form":_vm.form,"loading":_vm.loading},on:{"store":_vm.update}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }